// extracted by mini-css-extract-plugin
export default {"backdrop":"Confirm_backdrop__VclD5","fadeIn":"Confirm_fadeIn__0cOL6","confirmContainer":"Confirm_confirmContainer__VTcS3","slideUp":"Confirm_slideUp__4gv1a"};